<div class="pwd-hint" *ngIf="passwordComplexityPolicy$ | async as passwordComplexityPolicy">
  <div *ngFor="let regexKey of getKeys(passwordComplexityPolicy)">
    <div *ngIf="getPwdPolicyUnit(passwordComplexityPolicy, regexKey) > 0" class="info-row">
      <div *ngIf="validatesRegex(getPwdPolicyRegex(passwordComplexityPolicy, regexKey)); then done; else error"></div>
      <ng-template #done>
        <mat-icon color="success">{{ matIconDone }}</mat-icon>
        <span class="span-success">
          {{ getPwdPolicyTranslation(regexKey, getPwdPolicyUnit(passwordComplexityPolicy, regexKey)) }}
        </span>
      </ng-template>
      <ng-template #error>
        <mat-icon color="warn">{{ matIconError }}</mat-icon>
        <span class="span-warn">
          {{ getPwdPolicyTranslation(regexKey, getPwdPolicyUnit(passwordComplexityPolicy, regexKey)) }}
        </span>
      </ng-template>
    </div>
  </div>
</div>
